import { ArchiveIcon, InfoCircleIcon, TrashIcon } from "components/icons"
import Tooltip from "components/tooltip"
import { useState } from "react"


const DeletedTooltip = ({ data, position = "left" }) => {
    const [reference, setReference] = useState()
    const [isOpen, setIsOpen] = useState(false)

    return (
        <div className="flex items-center font-normal">
            <Tooltip showOverlay={false} onClose={() => setIsOpen(false)} position={position} isOpen={isOpen} reference={reference}>
                <span className="flex max-w-lg px-4 py-2 mr-2 space-x-2 text-xs rounded-2xl bg-neutral-100">
                    <div className="flex flex-wrap w-full whitespace-normal">
                        {data}
                    </div>
                </span>
            </Tooltip>
            <span ref={setReference} onMouseEnter={() => setIsOpen(true)} onMouseLeave={() => setIsOpen(false)} className="inline-flex items-center transition active:hover:scale-90">
                <InfoCircleIcon className="w-4 h-4" stroke={2} />
            </span>
        </div>
    )
}

export default DeletedTooltip